import type { FulfillmentOrderLine } from "../../fulfillment-order/types";
import { fulfillmentServiceProviderName } from "../../fulfillment-order/service";
import type { FeeAdjustmentLineDisplay, FeeAdjustmentLineDraft } from "../types";
import { feeMoneyCents, feeMoneyText } from "./feeAdjustmentMoney";

/** 草稿沿用确认件服务事实，调整总价仅使用实际成本的前后差额。 */
export function buildFeeAdjustmentDraftDisplay(draft: FeeAdjustmentLineDraft, source?: FulfillmentOrderLine): FeeAdjustmentLineDisplay {
  const beforeAmount = draft.adjustment_type === "add_service" ? 0n : feeMoneyCents(draft.expected_before?.amount);
  const afterAmount = feeMoneyCents(draft.after.amount);
  return {
    id: draft.draft_line_id,
    adjustment_type: draft.adjustment_type,
    source_confirmation_line_id: draft.source_confirmation_line_id,
    result_confirmation_line_id: source?.id ?? "",
    item_name: source?.itemNameSnapshot ?? draft.item_name ?? "新增费用",
    resource_type: source?.resourceType ?? draft.resource_type ?? "",
    service_provider_name_snapshot: source ? fulfillmentServiceProviderName(source) : draft.service_provider_name,
    settlement_supplier_name_snapshot: source?.settlementSupplierName ?? draft.settlement_supplier_name,
    before_item_spec: source?.itemSpecSnapshot,
    after_item_spec: source?.itemSpecSnapshot ?? draft.item_spec,
    confirmation_item_name: source?.itemNameSnapshot ?? draft.item_name,
    confirmation_item_spec: source?.itemSpecSnapshot ?? draft.item_spec,
    before: draft.expected_before,
    after: draft.after,
    cost_delta_amount: beforeAmount === null || afterAmount === null ? "" : feeMoneyText(afterAmount - beforeAmount),
    sales_amount_by_member: {},
  };
}

/** 展示字段与确认件列表对齐；历史变化描述仍使用 before/after 快照。 */
export function getFeeAdjustmentServiceProject(line: FeeAdjustmentLineDisplay) {
  return {
    name: line.confirmation_item_name || line.item_name,
    spec: line.confirmation_item_name ? line.confirmation_item_spec : line.after_item_spec,
  };
}
